import { Component, inject, Input } from '@angular/core';

import { AuthService } from '../../../core/services/auth.service';
import { GoogleAnalyticService } from '../../../core/services/google-analytic.service';

@Component({
  selector: 'app-booking-banner',
  templateUrl: './booking-banner.component.html',
  styleUrl: './booking-banner.component.scss',
})
export class BookingBannerComponent {
  @Input({ required: true }) countryName: string;
  @Input({ required: true }) cityName: string;

  readonly #authService = inject(AuthService);
  readonly #googleAnalyticService = inject(GoogleAnalyticService);

  setGoogleAnalytic() {
    this.#googleAnalyticService.setHotelAnalytic({
      activityName: 'Banner',
      activityType: 'Banner',
      countryName: this.countryName,
      cityName: this.cityName,
      userID: this.#authService.userId,
    });
  }
}
